import { transformEmrIntegrationDtoToEmrIntegration } from '@/entities/emr-integration/@x';
import { transformOrganizationDtoToOrganization } from '@/entities/organization/@x';
import type { GetCurrentUserResponseDto } from '@/shared/api/modules/users';
import type { CurrentUser, Session } from '../model/types';

export const transformCurrentUserDtoToCurrentUser = (
  currentUserDto: GetCurrentUserResponseDto
): CurrentUser => {
  const {
    id,
    fullName,
    email,
    createdAt,
    updatedAt,
    organizationId,
    profileUrl,
    createdBy,
    role,
    lastLogin,
    managedFacilities,
    organization,
    earliestSnapshotDate,
    canImpersonate,
    canDownloadStaffTemplate,
  } = currentUserDto;

  return {
    id: String(id),
    fullName: fullName,
    email: email,
    createdAt: createdAt,
    updatedAt: updatedAt,
    createdBy: createdBy
      ? {
          id: String(createdBy.id),
          email: createdBy.email,
          fullName: createdBy.fullName,
        }
      : null,
    lastLogin: lastLogin,
    emrIntegration: transformEmrIntegrationDtoToEmrIntegration(
      organization ? organization.emrIntegration : null
    ),
    organization: organization
      ? transformOrganizationDtoToOrganization(organization)
      : null,
    profileUrl: profileUrl || '',
    isOrganizationCreator: id === organization?.ownerId,
    canImpersonate: !!canImpersonate,
    canDownloadStaffTemplate: !!canDownloadStaffTemplate,
    earliestSnapshotDate: earliestSnapshotDate ?? null,
    role: role?.name ?? null,
    organizationId:
      organizationId === null ? null : String(currentUserDto.organizationId),
    isFacilitiesManager:
      id === organization?.ownerId && managedFacilities === 0
        ? true
        : managedFacilities !== 0,
  };
};

export const transformCurrentUserDtoToSession = (
  currentUserDto: GetCurrentUserResponseDto
): Partial<Session> => {
  const { organization, organizationId, role, permissions } = currentUserDto;

  return {
    isAuthenticated: true,
    isSuperAdmin:
      organization === null &&
      organizationId === null &&
      role?.organizationId === null,
    isContractor:
      organization === null &&
      organizationId === null &&
      role?.organizationId === null &&
      role?.name === 'Contractor',
    permissions: permissions || [],
  };
};
